import sal from 'sal.js';
import 'sal.js/dist/sal.css';

let salInstance = sal();
let salEnabled = true;

const switchAnimations = () => {
  const isMobile = window.innerWidth < 768;

  // If already disabled and still mobile, or already enabled and still desktop, do nothing
  if (isMobile && !salEnabled) return;
  if (!isMobile && salEnabled) return;

  // Try/catch prevents errors when sal internals are in a weird state
  try {
    salInstance.reset();

    if (isMobile) {
      salInstance.disable();
      salEnabled = false;
    } else {
      salInstance.enable();
      salEnabled = true;
    }
  } catch (e) {
    console.warn('sal.js error:', e);
  }
};

switchAnimations();

window.addEventListener('resize', () => {
  // Optional debounce for performance
  clearTimeout(window._salResizeTimer);
  window._salResizeTimer = setTimeout(switchAnimations, 150);
});


// Homepage Hero Animations
document.addEventListener('DOMContentLoaded', () => {
  const homepageHeros = document.querySelectorAll('.gb-block-tertiary-hero');

  if (homepageHeros.length === 0) return;

  homepageHeros.forEach(homepageHero => {
    if (window.innerWidth > 767) {
      animateHomepageHero(homepageHero);
    }
  });
});

function animateHomepageHero(homepageHero) {
  const homepageHeroLogo    = homepageHero.querySelector('.gb-block-tertiary-hero__logo img');

  // Fade in and Scale logo To normal size.
  gsap.to(homepageHeroLogo, {
    opacity: 1,
    scale: 1,
    duration: 1.2,
    ease: 'power2.inOut',
    onComplete: () => {
      gsap.to(homepageHeroLogo, {
        scale: 0.5,
        scrollTrigger: {
          trigger: homepageHero,
          start: "top top",
          end: "bottom top",
          scrub: true
        },
        ease: "power2.out",
        transformOrigin: "center center"
      });
      ScrollTrigger.refresh();
    }
  });
}

// Site Footer Logo Animations.
document.addEventListener('DOMContentLoaded', () => {
  const siteFooters = document.querySelectorAll('.gb-site-footer');

  if (siteFooters.length === 0) return;

  siteFooters.forEach(siteFooter => {
    if (window.innerWidth > 767) {
      animateSiteFooter(siteFooter);
    }
  });
});

function animateSiteFooter(siteFooter) {
  const footerLogo = siteFooter.querySelector('.gb-site-footer__logo img');
  
  if (footerLogo == null) return;

  // Start small.
  gsap.set(footerLogo, {
    scale: 0.5,
    transformOrigin: 'center center'
  });

  // Grow as footer scrolls into view; shrink when scrolling away.
  gsap.to(footerLogo, {
    scale: 1,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: siteFooter,
      start: 'top bottom',   // When footer enters viewport.
      end: 'bottom bottom',  // When footer is fully in view.
      scrub: true,
      invalidateOnRefresh: true
    }
  });

  ScrollTrigger.refresh();
}